export default __webpack_public_path__ + "static/media/client-1.49a2535a.webp";